// extracted by mini-css-extract-plugin
export default {"container":"iA-z","modal":"jA-z","dimensions":"kA-z","brandName":"lA-z","productName":"mA-z","labelValue":"nA-z","recipientEmail":"oA-z","recommendedFit":"pA-z","hiddenField":"qA-z"};